import React from 'react';
import { Route, Switch } from 'react-router-dom';
import KitchenDisplayList from '../../KitchenDisplay/Pages/KitchenDisplayList';
import AddKitchenDisplay from '../../KitchenDisplay/Pages/AddKitchenDisplay';
import EditKitchenDisplay from '../../KitchenDisplay/Pages/EditKitchenDisplay';
import ViewKitchenDisplay from '../../KitchenDisplay/Pages/ViewKitchenDisplay';

/**
 * Routes for measurement unit CRUD operations
 * @param {Object} props - Component props
 * @returns {JSX.Element} MeasurementUnitRoutes component
 */
const KitchenDisplayRoutes = (props) => {
  const { match } = props;
  const { path } = match;
  
  return (
    <Switch>
      <Route exact path={`${path}`} component={KitchenDisplayList} />
      <Route exact path={`${path}/add`} component={AddKitchenDisplay} />
      <Route exact path={`${path}/edit/:slack`} component={EditKitchenDisplay} />
      <Route exact path={`${path}/view/:slack`} component={ViewKitchenDisplay} />
    </Switch>
  );
};

export default KitchenDisplayRoutes;
